import { BrowserRouter } from "react-router-dom"
import { UIConfigContext } from "@digatex/digatex-ui-lib";
import { UI_CONFIG } from "../entities/properties";
import "../main.less";
import NavMenu from "../components/navMenu";
import RoutesNav from "../navigation/routesNav";
import { CommonPropertiesProvider } from "../contexts/commonPropertiesContext";
import { TabsProvider } from "../contexts/tabsContext";
import { FiltersProvider } from "../contexts/filtersContext";
import { UserSettingsProvider } from "../contexts/userSettingsContext";

function App() {

  return (
    <BrowserRouter>
      <UIConfigContext.Provider value={UI_CONFIG}>
        <UserSettingsProvider>
          <TabsProvider>
            <CommonPropertiesProvider>
              <FiltersProvider>
                <NavMenu />
                <RoutesNav />
              </FiltersProvider>
            </CommonPropertiesProvider>
          </TabsProvider>
        </UserSettingsProvider>
      </UIConfigContext.Provider>
    </BrowserRouter>
  )
}

export default App
